import React, { Component } from 'react';

class BtnSubmit extends Component {
  render() {
    return (
      <button
        type={this.props.type}
        className={`btn btn-${this.props.color} ${this.props.submitted ? 'disabled' : ''}`}
        disabled={this.props.submitted ? 'disabled' : ''}
        onClick={this.props.event ? this.props.event : null}
      >
        {
          this.props.submitted ?
            <div>
              <span className="sr-only"> {this.props.altText}</span>
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
          : this.props.text
        }
      </button>
    )
  }
}

export { BtnSubmit as SubmitButton }